<template>
  <section class="module-joinus">
    <NavComponent></NavComponent>
    <div class="bg">
      <div class="container">
       <div class="container-center">
          <p style="cursor:pointer" @click="goRelationPage">
            <strong>公司使命：</strong>用科技提升人类家园的生活品质
          </p>
          <p style="cursor:pointer" @click="goRelationPage">
            <strong>公司文化：</strong>格物致知，止于至善
          </p>
       </div>
      </div>
    </div>

    <div class="container title">
      <img src="../assets/joinus.png" alt="joinus" />
    </div>
     <div class="container jd add-content">
       <div class="container-center">
         <h4  @click="goRelationPage">短视频运营</h4>
          <h6>工作地点：北京</h6>
          <h6>一、工作职责</h6>
          <p>1、独立完成短视频创意和策划（不限于抖音/微信/快手等平台），拍摄、发布。</p>
          <p>2、熟悉各视频平台带货逻辑，独立进行案例拆解。</p>
          <p>3、根据运营数据、销售数据总结，调整运营策略，持续优化效果。</p>
          <p>4、负责公域流量到私域流量的运营工作，通过运营社群助力业务转化。</p>
          <h6>二、任职要求</h6>
          <p>1、2年及以上短视频（抖音/快手）运营策划、制作经验</p>
          <p>2、抖音、快手重度用户，懂得短视频/直播等运营技巧。</p>
          <p>3、良好的数据分析能力和逻辑思维，通过案例分析、数据分析不断提升运营方法。</p>
          <p>4、简历请附上视频作品。具有视频个人IP或商业成功作品者优先。</p>
          

          <h4  @click="goRelationPage">社群运营</h4>
          <h6>工作地点：北京</h6>
          <h6>一、工作职责</h6>
          <p>1、负责社群的日常运营策划，能为社群转化率和销售指标负责。</p>
          <p>2、负责销售商品战略制定与管理，对接上游供应商，持续优化SKU和分销管理。</p>
          <p>3、有用户运营和产品运营思维，为用户拉新、活跃、留存、转化生态闭环负责。</p>
          <p>4、负责十万规模级微信群运营，懂裂变工具和规模维护工具和方法。</p>
          <p>5、深刻理解流量生态，持续监测联盟流量健康度，并提供激活解决方案。</p>
          <h6>二、任职要求</h6>
          <p>1、擅长用户引导、互动、活动等各类策划及社群转化模式，能独立搭建社群运营体系。</p>
          <p>2、微信重度用户，掌握微信、微信群、公众号、小程序等使用“秘籍”。</p>
          <p>3、过往KPI中承担转化率和营收项优先。</p>
          <p>4、有对接供应商或toB行业工作经验优先。</p>

       </div>
    </div>
     <FooterComponent></FooterComponent>
  </section>
</template>

<script>
import NavComponent from '@/components/header.vue'
import FooterComponent from '@/components/footer.vue'
import util from "../util/util.js";
export default {
  components: {
    NavComponent,
    FooterComponent
  },
  methods: {
    goRelationPage(){
      util.goContact();
    }
  }
}
</script>

<style lang="scss" scoped>
.module-joinus {
  @media screen and (min-width: 769px){
      & {
          .bg {
            padding-top: 70px;
            height: 350px;
            background: url("../assets/product_banner.png") center bottom no-repeat;
            background-size: 100% 100%;
            p {
                color: #07C160;
                font-size: 28px;
            }
            .container-center{
              width: 600px;
              margin: 0 auto;
            }
          }
          .container-center{
            width: 600px;
            margin: 0 auto;
          }
          h4,
          h6 {
            margin: 2rem 0;
          }
      }
  }
  
  .title {
    padding: 2rem 0;
    text-align: center;
    img {
      max-width: 480px;
      width: 100%;
    }
  }
  .add-content{
    width: 80%;
  }
  
  h4{
    color: #07C160;
    cursor: pointer;
  }

  @media screen and (max-width: 768px){
      & {
          .bg {
            // padding-top: 70px;
            height: 10rem;
            background: url("../assets/product_banner.png") center bottom no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            p {
                color: #07C160;
                font-size: 1rem;
            }
            .container-center{
              width: 100%;
              margin: 0 auto;
            }
          }
          h4{
              font-size: 1rem;
          }
          h6,p{
            font-size: 0.9rem;
          }
          .add-content{
            width: 100%;
          }
          
      }
  }
}
</style>